module.exports = __webpack_public_path__ + "static/media/pizza-3.7a69d200.jpg";